export const normalizeZoneName = (name: string): string =>
  name.replace(/^\p{White_Space}+|\p{White_Space}+$/gu, '');

export const zoneNameError = (name: string): MessageDescriptor | null => {
  const normalized = normalizeZoneName(name);
  if (!normalized) return msg`Enter a Zone name.`;
  if ([...normalized].length > 100) return msg`Use 100 characters or fewer.`;
  if (/\p{Cc}/u.test(normalized)) return msg`Names cannot contain control characters.`;
  return null;
};
import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
